import { render, staticRenderFns } from "./Chronotachograph.vue?vue&type=template&id=01df8d92&scoped=true&"
import script from "./Chronotachograph.vue?vue&type=script&lang=js&"
export * from "./Chronotachograph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01df8d92",
  null
  
)

export default component.exports